<template>
  <b-col sm="12" md="12" lg="12" xl="12">
    <info-icon
      v-if="options.tooltip"
      v-b-tooltip.hover.right="options.tooltip"
      class="tooltip-icon"
    />
    <Colaborador
      :label="label"
      :id_usuario="id_colaborador"
      v-model="id_colaborador"
      @input="(v) => $emit('updateModel', { id_colaborador: v })"
    />
  </b-col>
</template>

<script>
import Colaborador from '@/components/Form/Colaborador';

export default {
  name: 'ColaboradorResponsavel',
  inject: ['validator', 'validateState'],

  components: {
    Colaborador,
  },

  created() {
    this.$validator = this.validator;
  },

  data() {
    return {
      id_colaborador: null,
    };
  },

  computed: {
    label() {
      if (this.options && this.options.label) return this.options.label;
      return 'Responsável pelo processamento';
    },
  },

  props: {
    isBusy: {
      type: Boolean,
    },
    options: {
      type: Object,
      required: false,
    },
  },
};
</script>
